<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 18 18"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#8391A3">
        <g>
          <g>
            <path
              d="M8-.03c4.435 0 8.03 3.595 8.03 8.03 0 4.435-3.595 8.03-8.03 8.03-4.435 0-8.03-3.595-8.03-8.03C-.03 3.565 3.566-.03 8-.03zm0 1C4.118.97.97 4.119.97 8S4.119 15.03 8 15.03s7.03-3.148 7.03-7.03S11.881.97 8 .97zM8 7.5c.245 0 .45.177.492.41L8.5 8v3.765c0 .276-.224.5-.5.5-.245 0-.45-.177-.492-.41l-.008-.09V8c0-.276.224-.5.5-.5zm0-3.265c.52 0 .941.422.941.941 0 .52-.421.942-.941.942s-.941-.422-.941-.942.421-.94.941-.94z"
              transform="translate(-408 -295) translate(280 208) translate(0 52) translate(129 36)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'InfoCircleIcon',
  props: {
    height: VueTypes.string.def('18'),
    width: VueTypes.string.def('18'),
  },
};
</script>

<style lang="scss"></style>
